declare namespace $ {

	type $mol_view__sub_shm_agent_app_sessions_head_1 = $mol_type_enforce<
		ReturnType< $shm_agent_app_sessions_head['controls'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_agent_app_sessions_head extends $shm_list_head {
		controls( ): readonly(any)[]
		search_showed( ): boolean
		Controls( ): $mol_view
	}
	
}

//# sourceMappingURL=head.view.tree.d.ts.map